import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=ce4f252e&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=ce4f252e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4f252e",
  null
  
)

export default component.exports